import { isDarkColor } from '@elfsight/lib-utils';
import type { FilterProps } from '@elfsight/widget-filters';
import {
  arrayFilterMethods,
  createFilter,
  DropdownTriggerButton,
  FilterDropdown
} from '@elfsight/widget-filters';
import { useSettings } from '@wu/widget-core';
import { isEqual } from 'es-toolkit';
import type { SalaryFilterOption } from '../types';
import { SalaryFilter } from './SalaryFilter';

export type SalaryDropdownProps = FilterProps<
  SalaryFilterOption[],
  {
    label: string;
    options: SalaryFilterOption[];
  }
>;

export const SalaryDropdown = createFilter(function UnboundDropdownTagsControl({
  filter,
  label,
  options
}: SalaryDropdownProps) {
  const { filtersAndSearchColor } = useSettings();
  const { resetSelectedValues, appliedSize, isApplied, isSelected } =
    arrayFilterMethods(filter);

  const getLabel = () => {
    if (filter.appliedValue?.length === 1) {
      const found = options.find(({ value }) =>
        isEqual(value, filter.appliedValue[0])
      );
      return found?.label ?? label;
    }
    return label;
  };

  return (
    <FilterDropdown
      trigger={
        <DropdownTriggerButton
          selected={isApplied}
          badge={appliedSize > 1 ? appliedSize : undefined}
          withBackground={!isDarkColor(filtersAndSearchColor)}
        >
          {getLabel()}
        </DropdownTriggerButton>
      }
      displayClearButton={isSelected}
      onClearRequest={resetSelectedValues}
      maxWidth={300}
      maxHeight={320}
    >
      <SalaryFilter filterName={filter.name} options={options} />
    </FilterDropdown>
  );
});
